import {ReactElement} from 'react';

import {PossibleObject} from '../../../types/PossibleObject';
import {FormFieldProps} from '../components/FormField';

/**
 * @deprecated - use platform Form instead
 */
export type FormFieldType<FormValues extends PossibleObject, Context extends PossibleObject> = <
  Value = any,
  Option = any,
  Multiple extends boolean = false,
>(
  props: FormFieldProps<FormValues, Context, Multiple>
) => ReactElement<FormFieldProps<FormValues, Context, Multiple>>;
